module.exports = __webpack_public_path__ + "static/media/thumb-nowinsg.7aa569a2.png";